import { GlobalAxios } from "../axios/axios-config";

const PATIENT_ENCOUNTER_EXECUTE_REQUEST_REPROCESS_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/PatientEncounterExecuteRequest/Reprocess";

export const reprocessPatientEncounterExecuteRequests = ({
  ids,
}: {
  ids: string[];
}) => {
  return GlobalAxios.post(PATIENT_ENCOUNTER_EXECUTE_REQUEST_REPROCESS_ROUTE, {
    ids,
  });
};
